/**
 * 自動ログアウトの判定（時計に触らない純粋な計算なので、そのまま試験できる）。
 *
 * 管理画面は名簿や操作履歴を扱うので、席を離れたまま開きっぱなしにならないよう、
 * しばらく操作が無ければログアウトする。
 */

/** 何も操作が無いときにログアウトするまでの時間（30分）。 */
export const IDLE_LIMIT_MS = 30 * 60 * 1000;

/** 最後の操作から限度を過ぎたか。 */
export function isIdleExpired(
  lastActiveAt: number,
  now: number,
  limitMs: number = IDLE_LIMIT_MS,
): boolean {
  return now - lastActiveAt >= limitMs;
}
